
import React from 'react';

const BookMockup: React.FC = () => {
  return (
    <div className="flex justify-center items-center w-full py-2 md:py-6">
      <div className="relative group transition-all duration-500 ease-in-out hover:-translate-y-2">
        {/* Resplandor de fondo para que la imagen resalte */}
        <div className="absolute inset-0 bg-purple-600/20 blur-[60px] rounded-full scale-75 group-hover:scale-100 transition-transform"></div>
        
        {/* Imagen del producto (que ya es un mockup) */}
        <div className="relative z-10">
          <img 
            src="https://i.postimg.cc/FsJsqtSr/2.jpg" 
            alt="El Método Invesmart" 
            className="w-full max-w-[280px] md:max-w-[420px] h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)] rounded-lg"
          />
        </div>
        
        {/* Sombra de apoyo */}
        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-[60%] h-6 bg-black/40 blur-xl rounded-full opacity-50 group-hover:opacity-30 transition-opacity"></div>
      </div>
    </div>
  );
};

export default BookMockup;
